
import { createClient } from '@supabase/supabase-js';

// Directly use your provided Supabase project public URL and anon key
const supabaseUrl = "https://mtmiugwgxpeughjsxnnl.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im10bWl1Z3dneHBldWdoanN4bm5sIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1MDkyMjcsImV4cCI6MjA2MTA4NTIyN30.sQneEE2yxuKgPjJ2DLf7cBHNIjfgyjFOrawc-Hn2HqI";

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase environment variables are not set!');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
